module.exports = __webpack_public_path__ + "14four/static/media/errorCopy.30bb291a.png";